import { render, staticRenderFns } from "./imprint.vue?vue&type=template&id=95fe1f90&scoped=true"
import script from "./imprint.vue?vue&type=script&lang=js"
export * from "./imprint.vue?vue&type=script&lang=js"
import style0 from "./imprint.vue?vue&type=style&index=0&id=95fe1f90&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95fe1f90",
  null
  
)

export default component.exports